/**
 * Default colors for the pie chart slices.
 */
export const PIE_CHART_SLICE_COLORS = [
  '#A3E635',
  '#B70071',
  '#8333FF',
  '#001C90',
  '#DD63B1',
  '#EC4899',
  '#F59E0B',
  '#A16207',
  '#2563EB',
  '#312E81',
  '#4F46E5',
  '#8B5CF6',
  '#BE123C',
  '#22D3EE',
  '#34D399',
  '#BE185D',
  '#86198F',
  '#84CC16',
  '#FCD34D',
]

/**
 * Color for the others slice.
 */
export const PIE_CHART_OTHERS_COLOR = '#BFBFBF'
